import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Copy } from 'lucide-react'
// import { setLoaderShow } from "../../redux/slice/seriesSlice";
// import {socket} from "../../socket/Socket";
// import "./style.css";
import moment from "moment";
import Barcode from "react-barcode";
import { Cut, Printer } from "react-thermal-printer";
// import { selectSocket } from "../../redux/slice/socketSlice";
import { SocketState } from "../../../context/SocketProvider";
import { selectPickBetList, selectPickPrintTicket3d, setPrintTicketData3d } from "../../../redux/3d_game_Slice/gameinfo3d";
import "./resultPopUp.scss";
import ModalContainer from "../../../2d-game/modals/ModalContainer";

import { AuthState } from "../../../context/AuthProvider";

function PrintPage3d() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { socket } = SocketState()
  const { userDetail } = AuthState()
  const lotteryList = useSelector(selectPickBetList);
  const [previewTicket, setPreviewTicket] = useState(null);
  const [copiedTicket, setCopiedTicket] = useState(null);


  useEffect(() => {
    // dispatch(setLoaderShow(true))
    var data = {
      en: "PICK_THREE_GET_BET_LISTS",
      data: {},
    };
    socket.emit("req", data);
  }, [])

  let getPrintData = (ticket) => () => {
    console.log(ticket)
    setPreviewTicket(ticket);
  };

  const handleConfirmPrint = () => {
    if (previewTicket) {
      let data = {
        en: "PICK_THREE_PRINT_TICKETS",
        data: {
          ticket_id: previewTicket.ticket_id,
        },
      };
      socket.emit("req", data);
      setPreviewTicket(null);
    }
  };

  const handleCopy = async (ticket_id) => {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(ticket_id)
        setCopiedTicket(ticket_id)
        setTimeout(() => setCopiedTicket(null), 1000)
      } catch (err) {
        console.error('Clipboard write failed:', err)
        alert('Failed to copy ticket ID')
      }
    } else {
      // Fallback for unsupported browsers
      const tempInput = document.createElement('input')
      tempInput.value = ticket_id
      document.body.appendChild(tempInput)
      tempInput.select()
      document.execCommand('copy')
      document.body.removeChild(tempInput)
      setCopiedTicket(ticket_id)
      setTimeout(() => setCopiedTicket(null), 1000)
    }
  }

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    }
  }, [])



  const renderStatus = (status) => {
    if (status === 0) {
      return <span className="p-3 rounded-full text-sm font-semibold bg-yellow-100 text-yellow-800">Not Result Declare</span>;
    }
    if (status === 1) {
      return <span className="p-3 rounded-full text-sm font-semibold bg-blue-100 text-blue-800">Cancelled</span>;
    }
    if (status === 2) {
      return <span className="p-3 rounded-full text-sm font-semibold bg-indigo-100 text-indigo-800">Not Claim</span>;
    }
    if (status === 3) {
      return <span className="p-3 rounded-full text-sm font-semibold bg-green-100 text-green-800">Claimed</span>;
    }
    if (status === 4) {
      return <span className="p-3 rounded-full text-sm font-semibold bg-red-100 text-red-800">Loss</span>;
    }
    return <span className="p-3 rounded-full text-sm font-semibold bg-gray-100 text-gray-700">Unknown</span>;
  };

  const parseStraightWinCards = (winCards) => {
    // "A=000&B=000&C=000"
    const winSet = new Set();

    if (!winCards) return winSet;

    winCards.split("&").forEach(pair => {
      const [prefix, value] = pair.split("=");
      if (prefix && value) {
        winSet.add(prefix + value); // A000, B000, C000
      }
    });

    return winSet;
  };

  return (
    <>
      <ModalContainer title={'RePrint'} navigation={'/3d'} style={{ zIndex: 1056 }}>
        <div>
          {/* No Data */}
          {!lotteryList.length && (
            <div className='flex w-[90%] mx-auto flex-wrap h-[calc(100vh-20vh)] overflow-y-auto'>
              <div className='flex justify-center w-full pt-10'>
                <p className='text-center font-bold text-[18px]'>No Data Found</p>
              </div>
            </div>
          )}

          {/* List */}
          {lotteryList.length > 0 && (
            <div className='mt-5'>
              {/* Header */}
              <div className='w-full border-b rounded border-gray-200 py-3.5 mb-2 bg-[#bdbaba] text-black flex px-3'>
                <div className='w-1/6 text-center font-semibold text-[17px]'>Date</div>
                <div className='w-1/6 text-center font-semibold text-[17px]'>Time</div>
                <div className='w-1/6 text-center font-semibold text-[17px]'>Ticket ID</div>
                <div className='w-1/6 text-center font-semibold text-[17px]'>Status</div>
                <div className='w-1/6 text-center font-semibold text-[17px]'>Win Amount</div>
                <div className='w-1/6 text-center font-semibold text-[17px]'>Bet Amount</div>
                <div className='w-1/6 text-center font-semibold text-[17px]'></div>
              </div>

              {/* Body */}
              <div className='h-[calc(100vh-32vh)] overflow-y-auto'>
                {lotteryList.map((Lottery, index) => (
                  <div
                    key={index}
                    className='w-full border-b border-gray-200 py-3.5 mb-2 bg-white flex px-3'
                  >
                    <div className='w-1/6 text-center font-semibold text-[16px]'>
                      {Lottery.deal_date}
                    </div>

                    <div className='w-1/6 text-center font-semibold text-[16px]'>
                      {Lottery.deal_time}
                    </div>

                    {/* Ticket ID + Copy */}
                    <div className='w-1/6 text-center font-semibold text-[16px] flex items-center justify-center gap-2'>
                      <span>{Lottery.ticket_id}</span>
                      <button
                        onClick={() => handleCopy(Lottery.ticket_id)}
                        className='text-gray-500 hover:text-blue-600 transition-all'
                        title='Copy Ticket ID'
                      >
                        <Copy size={18} />
                      </button>
                      {copiedTicket === Lottery.ticket_id && (
                        <span className='text-green-500 text-sm animate-pulse'>
                          Copied!
                        </span>
                      )}
                    </div>

                    <div className='w-1/6 text-center font-semibold text-[15px] flex justify-center'>
                      {renderStatus(Lottery.status)}
                    </div>
                    <div className='w-1/6 text-center font-semibold text-[15px] flex justify-center'>
                      {Math.floor(Lottery.total_win_amount)}
                    </div>

                    <div className='w-1/6 text-center font-semibold text-[16px]'>
                      {Math.floor(Lottery.total_bet_amount)}
                    </div>

                    <div className='w-1/6 text-center font-semibold text-[16px]'>
                      <button
                        className='bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded w-2/3'
                        type='button'
                        onClick={getPrintData(Lottery)}

                      >
                        {userDetail?.print ? "RePrint" : "View"}
                      </button>

                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

      </ModalContainer>

      {/* Popup Preview Modal */}
      {previewTicket && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50" style={{ zIndex: 1111 }}>
          <div className="bg-white w-[800px] rounded-lg shadow-lg p-5">
            <h2 className="text-lg font-bold mb-4 text-center">Ticket Preview</h2>


            <table className="w-full border-collapse mb-4">
              <thead>
                <tr>
                  <td className="font-semibold border px-2 py-1">Date:</td>
                  <td className="border px-2 py-1">{previewTicket.deal_date}</td>
                  <td className="font-semibold border px-2 py-1">Time:</td>
                  <td className="border px-2 py-1">{previewTicket.deal_time}</td>
                </tr>
                <tr>
                  <td className="font-semibold border px-2 py-1">Ticket ID:</td>
                  <td className="border px-2 py-1">{previewTicket.ticket_id}</td>
                  <td className="font-semibold border px-2 py-1">Bet Amount:</td>
                  <td className="border px-2 py-1">{Math.floor(previewTicket.total_bet_amount)}</td>
                </tr>
                {!userDetail?.print && (
                  <>
                    <tr>
                      <td
                        colSpan={4}
                        className="border px-2 py-2 text-center font-bold bg-gray-200"
                        style={{ fontSize: "16px" }}
                      >
                        Bet Details
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={4}>
                        <div
                          style={{
                            maxHeight: "250px",
                            overflowY: "auto",
                            overflowX: "hidden",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            background: "#f9f9f9",
                            padding: "4px",
                          }}
                        >
                          {/* LOOP ON MAIN CATEGORIES */}
                          {Object.entries(previewTicket.card_details).map(
                            ([category, numbers], catIndex) => (
                              <div
                                key={catIndex}
                                style={{
                                  marginBottom: "12px",
                                  borderBottom: "1px dashed #ccc",
                                  paddingBottom: "10px",
                                }}
                              >
                                {/* CATEGORY TITLE */}
                                <h3
                                  style={{
                                    fontWeight: "700",
                                    fontSize: "15px",
                                    marginBottom: "6px",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {category.replace("_", " ")}
                                </h3>

                                {/* TABLE FOR ENTRIES */}
                                <table
                                  style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    textAlign: "center",
                                  }}
                                >
                                  <tbody>
                                    {
                                      // chunk 15 per row
                                      Object.entries(numbers)
                                        .reduce((rows, entry, idx) => {
                                          if (idx % 15 === 0) rows.push([]);
                                          rows[rows.length - 1].push(entry);
                                          return rows;
                                        }, [])
                                        .map((row, rowIndex) => (
                                          <tr key={rowIndex}>
                                            {row.map(([num, amt], i) => {
                                              const straightWinSet = parseStraightWinCards(previewTicket.win_cards);

                                              const isWin =
                                                category === "straight" && straightWinSet.has(num);

                                              return (
                                                <td
                                                  key={i}
                                                  style={{
                                                    fontSize: "14px",
                                                    fontWeight: "600",
                                                    padding: "0.2rem",
                                                    borderBottom: "1px solid #ddd",
                                                    lineHeight: "1rem",
                                                    verticalAlign: "unset",
                                                  }}
                                                >
                                                  {num}
                                                  <br />
                                                  <span
                                                    style={{
                                                      border: "1px solid #fff",
                                                      padding: "2px 9px",
                                                      color: "#000",
                                                      background: isWin ? "#37c22b" : "#d9ddff",
                                                      borderRadius: "4px",
                                                      display: "inline-block",
                                                      marginTop: "2px",
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    {amt}
                                                  </span>

                                                  {/* OPTIONAL: Win label */}
                                                  {isWin && (
                                                    <div style={{ fontSize: "11px", color: "green" }}>
                                                      WIN
                                                    </div>
                                                  )}
                                                </td>
                                              );
                                            })}

                                          </tr>
                                        ))
                                    }
                                  </tbody>
                                </table>
                              </div>
                            )
                          )}
                        </div>
                      </td>
                    </tr>
                  </>
                )}
              </thead>
            </table>


            <div className="flex justify-end gap-3 mt-6">
              <button
                className="bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 px-4 rounded"
                onClick={() => setPreviewTicket(null)}
              >
                Cancel
              </button>

              {userDetail?.print ? <button
                className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded"
                onClick={handleConfirmPrint}
              >
                RePrint
              </button> : ""}
            </div>
          </div>
        </div>
      )}

      <div id="rePrintContainer">
        <Content />
      </div>
    </>
  );
}

// ... rest of the code (Content component and other functions remain the same)
let qty = 0

let Content = () => {
  const dispatch = useDispatch()
  let pickThreeBet = useSelector(selectPickPrintTicket3d)
  const [printObj, setPrintObj] = useState({})
  const [newPrintObj, setNewPrintObj] = useState([])
  const [labels, setlabels] = useState({ box: 'Box', straight: 'STR', split_pair: 'SP', front_pair: 'FP', back_pair: 'BP', any_two: 'AP' })

  // Group bets by type and series
  const groupedBets = useMemo(() => {
    const groups = {};
    newPrintObj.forEach((bet) => {
      // For reprint, we don't have selectedItems, so we'll assume all series (A,B,C)
      const seriesArray = pickThreeBet?.series_type
        ? pickThreeBet.series_type.split(",")
        : ["A", "B", "C"];

      seriesArray.forEach((series) => {
        if (!groups[bet.type]) {
          groups[bet.type] = [];
        }
        groups[bet.type].push({
          number: bet.name,
          value: bet.value,
          series: series
        });
      });
    });
    return groups;
  }, [newPrintObj]);

  useEffect(() => {
    qty = 0
    if (pickThreeBet) {
      let { card_details } = pickThreeBet
      let obj = {}
      let newObj = []

      Object.keys(card_details).map((key, index) => {
        Object.keys(card_details[key]).map((card, index) => {
          if (obj[key]) {
            obj[key].totalCount += 1;
            obj[key].totalValue += card_details[key][card] * (1);
            obj[key].seriesAllfield = [
              ...obj[key].seriesAllfield,
              { name: card, value: card_details[key][card], type: key },
            ];
            newObj.push({ name: card, value: card_details[key][card], type: key })
          } else {
            newObj.push({ name: card, value: card_details[key][card], type: key })
            obj[key] = {
              totalCount: 1,
              totalValue: card_details[key][card] * (1),
              multiply: card_details[key][card],
              seriesAllfield: [{ name: card, value: card_details[key][card], type: key }],
            };
          }
          qty += card_details[key][card] / 10
        })
      })

      setPrintObj(obj)
      setNewPrintObj(newObj)
    }
  }, [pickThreeBet])

  useEffect(() => {
    if (Object.keys(printObj).length > 0) {
      var printContainer3d =
        document.getElementById("rePrintContainer").innerHTML;
      var printWindow3d = window.open("", "_blank");
      if (printWindow3d) {
        printWindow3d.document.open();
        printWindow3d.document.write(`<html>
          <head>
              <title> 3D</title>
            <link href="https://fonts.googleapis.com/css2?family=Anek+Malayalam:wght@300&family=BIZ+UDGothic&family=League+Gothic&family=Mukta:wght@200&family=Roboto+Condensed:wght@400&family=Roboto:wght@400&display=swap" rel="stylesheet">
          <!-- <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script> -->
          <script src="../JsBarcode.all.min.js"></script>
          </head>
          <style>
          @media print {
          
              html,
              body {
                  width: 62mm;
                  height: auto;
                  position: absolute;
              }
          }
          
          .printme {
              display: none;
          }
          
          @media print {
              .no-printme {
                  display: none;
              }
          
              .printme {
                  display: block;
              }
          
              .pagebreak {
                  page-break-before: always;
              }
          
              /* page-break-after works, as well */
          }
          
          #invoice {
              .. max-width: 62mm;
              height: auto;/min-height: 60mm;/
          }
          
          #invoice12 {
              .. max-width: 62mm;
              height: auto;/min-height: 60mm;/
          }
          
          body {
          
              font-family: 'Roboto', sans-serif;
          }
          
          table {
          
              font-family: 'Roboto', sans-serif;
          }
          h2{
              font-family: 'Roboto', sans-serif;
          }
          p{
              font-family: 'Roboto', sans-serif;
          }
          #invoice-POS {
              padding: 0px;
              width: 62mm;
              background: none;
              margin-top: 0mm !important;
          
          }
          
          #invoice-POS ::selection {
              background: #f31544;
          
          }
          
          #invoice-POS ::moz-selection {
              background: #f31544;
          
          }
          
          #invoice-POS h1 {
              font-size: 1em;
              font-weight: 600;
              font-family: 'Roboto', sans-serif;
              margin: 0px 0px 5px 0px;
          
          }
          
          #invoice-POS h2 {
              font-size: 0.8em;
              font-family: 'Roboto', sans-serif;
              margin: 4px 0px;
            font-size:12px;
          }
          
          
          
          #invoice-POS h3 {
              font-size: 1.2em;
              font-weight: 600;
              line-height: 2em;
              font-family: 'Roboto', sans-serif;
          
          }
          
          #invoice-POS p {
              color: #000;
              font-size: 0.8em;
              line-height: 0.8em;
              margin: 5px 0px;
              font-weight: 600 !important;
              font-family: 'Roboto', sans-serif;
          
          }
          
          #invoice-POS #top,
          #invoice-POS #mid,
          #invoice-POS #bot {
              /* Targets all id with 'col-' */
              border-bottom: 0px solid #eee;
          
          }
          
          #invoice-POS #top {
              min-height: 0px;
              margin-bottom: -3px;
          }
          
          #invoice-POS #mid {
              min-height: 30px;
          }
          
          #invoice-POS #bot {
              min-height: 50px;
          }
          
          #invoice-POS #top .logo {
              height: 60px;
              width: 60px;
              background: url(assets/img/doctors/logo3.png) no-repeat;
              background-size: 60px 60px;
          }
          
          #invoice-POS .clientlogo {
              float: left;
              height: 60px;
              width: 60px;
              background: url(assets/img/doctors/logo3.png) no-repeat;
              background-size: 60px 60px;
              border-radius: 50px;
          }
          
          #invoice-POS .info {
              display: block;
              margin-left: 0;
          }
          
          #invoice-POS .title {
              float: right;
          }
          
          #invoice-POS .title p {
              text-align: right;
          }
          
          #invoice-POS table {
              width: 40mm;
              border-collapse: collapse;
              text-align:center;
              line-height:11px;
              font-weight:600 !important;
          }
          
          #invoice-POS .tabletitle {
              font-size: .8em;
          
          }
          
          #invoice-POS .service {
              border-bottom: #fff;
              
          }
          
          #invoice-POS .item {
              width: 24mm;
          }
          
          #invoice-POS .itemtext {
              font-size: .8em;
          
          }
          
          #invoice-POS #legalcopy {
              margin-top: 5mm;
              text-align: center;
          }
          
          
          </style>
          
          <body style={{ margin:"0px 8px" }}>`)
        printWindow3d.document.write(printContainer3d);
        printWindow3d.document.write("</body></html>");
        printWindow3d.document.close();
        printWindow3d.focus();
        setTimeout(function () {
          printWindow3d.print();
          printWindow3d.close();
          dispatch(setPrintTicketData3d(null))
        }, 500);
      }
    }
  }, [printObj]);

  if (!Object.keys(printObj).length) {
    return null;
  }

  return (
    <>
      <Printer type="epson" characterSet="korea">
        <div className="printArea" style={{
          width: "58mm",
          fontFamily: "Arial, sans-serif",
          padding: "2px",
          fontSize: "14px"
        }}>

          {/* Header Section */}
          <div style={{ textAlign: "center", marginBottom: "4px" }}>
            <h2 style={{ fontSize: "14px", margin: "2px 0", fontWeight: "bold" }}>Super999 Lotto 3D </h2>
            <p style={{ margin: "2px 0", fontStyle: "italic" }}>(Ticket valid for 10 Days)</p>
            
        {localStorage.getItem('is_gst') === "true"
          ? `GST No : ${localStorage.getItem('gst')}`
          : ""
      }
            <p style={{ margin: "2px 0" }}>Amusement Only</p>
            <p style={{ margin: "2px 0" }}>Reprint Ticket</p>
          </div>

          <hr style={{ borderTop: "1px dashed #000", margin: "4px 0" }} />

          {/* Ticket Info Section */}
          <div style={{ marginBottom: "6px" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Draw:</span>
              <span>{pickThreeBet?.deal_date} {pickThreeBet?.deal_time}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Desk:</span>
              <span>{pickThreeBet?.user_name}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Coupen Time:</span>
              <span>{moment(pickThreeBet?.draw_time).format("DD-MM-YYYY hh:mm A")}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" }}>
              <span>Qty: {qty}</span>
              <span>Point: {pickThreeBet?.total_bet_amount}</span>
            </div>
          </div>

          <hr style={{ borderTop: "1px dashed #000", margin: "4px 0" }} />

          {/* Betting Groups Section */}
          <div style={{ marginBottom: "6px" }}>

            {Object.entries(groupedBets).map(([type, bets]) => {
              // split into chunks of 3 for one line
              const chunks = [];
              for (let i = 0; i < bets.length; i += 3) {
                chunks.push(bets.slice(i, i + 3));
              }

              return (
                <div
                  key={type}
                  style={{
                    width: "58mm",
                    maxWidth: "58mm",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "bold",
                      textTransform: "capitalize",
                      fontSize: "14px",
                    }}
                  >
                    {labels[type]}:
                  </div>

                  {chunks.map((chunk, idx) => (
                    <div
                      key={idx}
                      style={{
                        fontWeight: "bold",
                        fontSize: "14px",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {chunk.map((bet, i) => (
                        <span key={i} style={{ marginRight: "10px" }}>
                          {/* {bet.series} */}
                          {bet.number}<span style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                          }}>*</span>{bet.value / 10}
                        </span>
                      ))}
                    </div>
                  ))}
                </div>
              );
            })}
          </div>

          <hr style={{ borderTop: "1px dashed #000", margin: "4px 0" }} />

          {/* Barcode Section */}
          <div style={{ textAlign: "center", marginTop: "4px" }}>
            <p style={{ margin: "2px 0" }}>{pickThreeBet?.ticket_id}</p>
            {pickThreeBet?.ticket_id && (
              <Barcode
                value={pickThreeBet?.ticket_id}
                width={1}
                height={30}
                displayValue={false}
                margin={0}
              />
            )}
          </div>

        </div>
        <Cut />
      </Printer>
    </>
  );
};

export default PrintPage3d;
